import $ from 'jquery';

import Payment from 'app/src/payments/Payment';

import RetailModel from './RetailModel';

export default class PaymentLinkDeposit extends RetailModel {
  constructor(...args) {
    super(...args);
  }

  refundPayment({ amount } = {}) {
    let deferred = $.Deferred();
    let obj = this.clone();
    let refundEndpoint = '/admin/sale/payment-link/';
    let paymentID = this.get('paymentID');

    // @TODO: FAST FOLLOW LSR-33112 - separate this concern
    if (Payment.isCardOnFilePaymentID(paymentID)) {
      // Extract UUID part after the last underscore
      // Handles both: cof__[uuid]
      // and: cof_[4digits]_[uuid]
      paymentID = paymentID.substring(paymentID.lastIndexOf('_') + 1);
      refundEndpoint = '/admin/sale/processing/';
      obj.set({
        amount,
        shopID: this.get('shopID'),
        paymentID,
      });
    } else {
      obj.set({
        amount,
        shopID: this.get('shopID'),
      });
    }

    $.ajax({
      url: `${refundEndpoint}${paymentID}/refund`,
      method: 'POST',
      data: JSON.stringify(obj.toJSON()),
    })
      .done((data) => {
        this.set(data);
        deferred.resolve();
      })
      .fail(() => {
        deferred.reject();
      });

    return deferred.promise();
  }
}
